/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrainstormVariationsChat,
    BrainstormVariationsChatFromJSON,
    BrainstormVariationsChatToJSON,
    BulkOperationsRequestBody,
    BulkOperationsRequestBodyFromJSON,
    BulkOperationsRequestBodyToJSON,
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    Variation,
    VariationFromJSON,
    VariationToJSON,
    VariationMap,
    VariationMapFromJSON,
    VariationMapToJSON,
    VariationRequestBody,
    VariationRequestBodyFromJSON,
    VariationRequestBodyToJSON,
    Variations,
    VariationsFromJSON,
    VariationsToJSON,
} from '../models';

export interface ArchiveVariationsRequest {
    project_id: number;
    flag_key: string;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface BrainstormVariationsRequest {
    project_id: number;
    flag_key: string;
    brainstorm_variations_chat: BrainstormVariationsChat;
}

export interface CreateVariationRequest {
    project_id: number;
    flag_key: string;
    variation_request_body: VariationRequestBody;
}

export interface DeleteVariationRequest {
    project_id: number;
    flag_key: string;
    variation_key: string;
}

export interface FetchVariationRequest {
    project_id: number;
    flag_key: string;
    variation_key: string;
}

export interface ListVariationsRequest {
    project_id: number;
    flag_key: string;
    per_page?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListVariationsSortEnum>;
    archived?: boolean;
    enabled?: boolean;
    in_use?: boolean;
    query?: string;
}

export interface UnarchiveVariationsRequest {
    project_id: number;
    flag_key: string;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface UpdateVariationsRequest {
    project_id: number;
    flag_key: string;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class VariationsApi extends runtime.BaseAPI {

    /**
     * Archive one or more Variations for a Flag.  This operation corresponds to the `archive_url` in a Variations response. 
     * Archive Variations
     */
    async archiveVariationsRaw(requestParameters: ArchiveVariationsRequest): Promise<runtime.ApiResponse<VariationMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling archiveVariations.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling archiveVariations.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling archiveVariations.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations/archived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationMapFromJSON(jsonValue));
    }

    /**
     * Archive one or more Variations for a Flag.  This operation corresponds to the `archive_url` in a Variations response. 
     * Archive Variations
     */
    async archiveVariations(requestParameters: ArchiveVariationsRequest): Promise<VariationMap> {
        const response = await this.archiveVariationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Brainstorm variations definitions using AI.
     */
    async brainstormVariationsRaw(requestParameters: BrainstormVariationsRequest): Promise<runtime.ApiResponse<BrainstormVariationsChat>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling brainstormVariations.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling brainstormVariations.');
        }

        if (requestParameters.brainstorm_variations_chat === null || requestParameters.brainstorm_variations_chat === undefined) {
            throw new runtime.RequiredError('brainstorm_variations_chat','Required parameter requestParameters.brainstorm_variations_chat was null or undefined when calling brainstormVariations.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations/brainstorm`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrainstormVariationsChatToJSON(requestParameters.brainstorm_variations_chat),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrainstormVariationsChatFromJSON(jsonValue));
    }

    /**
     * Brainstorm variations definitions using AI.
     */
    async brainstormVariations(requestParameters: BrainstormVariationsRequest): Promise<BrainstormVariationsChat> {
        const response = await this.brainstormVariationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a new Variation for a specific Flag in a project.  This operation corresponds to the `create_url` in a Variations response.  Required properties must be present in the request body. 
     * Create a New Variation
     */
    async createVariationRaw(requestParameters: CreateVariationRequest): Promise<runtime.ApiResponse<Variation>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createVariation.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling createVariation.');
        }

        if (requestParameters.variation_request_body === null || requestParameters.variation_request_body === undefined) {
            throw new runtime.RequiredError('variation_request_body','Required parameter requestParameters.variation_request_body was null or undefined when calling createVariation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VariationRequestBodyToJSON(requestParameters.variation_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationFromJSON(jsonValue));
    }

    /**
     * Creates a new Variation for a specific Flag in a project.  This operation corresponds to the `create_url` in a Variations response.  Required properties must be present in the request body. 
     * Create a New Variation
     */
    async createVariation(requestParameters: CreateVariationRequest): Promise<Variation> {
        const response = await this.createVariationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete a Variation for a Flag.  There will be no way to access this data after deletion. If you want to stop seeing a Variation without deleting it permanently, try archiving instead. 
     * Delete a Variation
     */
    async deleteVariationRaw(requestParameters: DeleteVariationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteVariation.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling deleteVariation.');
        }

        if (requestParameters.variation_key === null || requestParameters.variation_key === undefined) {
            throw new runtime.RequiredError('variation_key','Required parameter requestParameters.variation_key was null or undefined when calling deleteVariation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations/{variation_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"variation_key"}}`, encodeURIComponent(String(requestParameters.variation_key))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete a Variation for a Flag.  There will be no way to access this data after deletion. If you want to stop seeing a Variation without deleting it permanently, try archiving instead. 
     * Delete a Variation
     */
    async deleteVariation(requestParameters: DeleteVariationRequest): Promise<void> {
        await this.deleteVariationRaw(requestParameters);
    }

    /**
     * Fetch a single Variation for a Flag by its key.  This operation corresponds to the `fetch_variation_url` in a Variations response. 
     * Fetch a Single Variation
     */
    async fetchVariationRaw(requestParameters: FetchVariationRequest): Promise<runtime.ApiResponse<Variation>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchVariation.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling fetchVariation.');
        }

        if (requestParameters.variation_key === null || requestParameters.variation_key === undefined) {
            throw new runtime.RequiredError('variation_key','Required parameter requestParameters.variation_key was null or undefined when calling fetchVariation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations/{variation_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"variation_key"}}`, encodeURIComponent(String(requestParameters.variation_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationFromJSON(jsonValue));
    }

    /**
     * Fetch a single Variation for a Flag by its key.  This operation corresponds to the `fetch_variation_url` in a Variations response. 
     * Fetch a Single Variation
     */
    async fetchVariation(requestParameters: FetchVariationRequest): Promise<Variation> {
        const response = await this.fetchVariationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of Variations for a specific Flag in a Project  You can use query parameters to filter/sort the response. 
     * List Variations
     */
    async listVariationsRaw(requestParameters: ListVariationsRequest): Promise<runtime.ApiResponse<Variations>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listVariations.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling listVariations.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.in_use !== undefined) {
            queryParameters['in_use'] = requestParameters.in_use;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationsFromJSON(jsonValue));
    }

    /**
     * Get a list of Variations for a specific Flag in a Project  You can use query parameters to filter/sort the response. 
     * List Variations
     */
    async listVariations(requestParameters: ListVariationsRequest): Promise<Variations> {
        const response = await this.listVariationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unarchive one or more Variations for a Flag.  This operation corresponds to the `unarchive_url` in a Variations response. 
     * Unarchive Variations
     */
    async unarchiveVariationsRaw(requestParameters: UnarchiveVariationsRequest): Promise<runtime.ApiResponse<VariationMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling unarchiveVariations.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling unarchiveVariations.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling unarchiveVariations.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations/unarchived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationMapFromJSON(jsonValue));
    }

    /**
     * Unarchive one or more Variations for a Flag.  This operation corresponds to the `unarchive_url` in a Variations response. 
     * Unarchive Variations
     */
    async unarchiveVariations(requestParameters: UnarchiveVariationsRequest): Promise<VariationMap> {
        const response = await this.unarchiveVariationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update one or more Variations for a specific Flag in a project using a JSON patch structure. 
     * Update Variations
     */
    async updateVariationsRaw(requestParameters: UpdateVariationsRequest): Promise<runtime.ApiResponse<VariationMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateVariations.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling updateVariations.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateVariations.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variations`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariationMapFromJSON(jsonValue));
    }

    /**
     * Update one or more Variations for a specific Flag in a project using a JSON patch structure. 
     * Update Variations
     */
    async updateVariations(requestParameters: UpdateVariationsRequest): Promise<VariationMap> {
        const response = await this.updateVariationsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListVariationsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc'
}
